import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Row } from "reactstrap";
import { H6, P } from "../../../AbstractElements";
import {
  TaskHeadings1,
  TaskHeadings2,
  TaskData1,
  TaskData2,
} from "../../../Data/Trips/TripDetails";
import { Star } from "react-feather";
import moment from "moment";

const TripDetails = ({bookingObj,tripObj}) => {
  const Table1Data=TaskHeadings1.map((element, i) => {
    let value=tripObj[element.value]?tripObj[element.value]:'-'
    if(element.value=='bookingTime' && value!='-'){
      value=moment(value).format('MMM DD,YYYY HH:mm')
    }
    if(element.value == "packageName" && value == "-"){
      value = 'Based on kilometers'
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  })

  const Table2Data=TaskHeadings2.map((element, i) => {
    let value;
    if(element.value=="tripStartTime" || element.value=="tripEndTime"){
      value=tripObj[element.value]?tripObj[element.value]:'-'
    }else{
      value=tripObj[element.value]?tripObj[element.value]:'-'
    }
    if((element.value=='pickUpDateTime' || element.value=="tripStartTime" || element.value=="tripEndTime") && value!='-'){
      value=moment(value).format('MMM DD,YYYY HH:mm')
    }
    if (element.value == "paymentModeType" && value == "Cash") {
      value = 'Postpaid'
    }
    if (element.value == "paymentModeType" && value == "CreditCustomer") {
      value = 'Prepaid (CreditCustomer)'
    }
    if (element.value == "paymentModeType" && value == "CreditCard") {
      value = 'Prepaid'
    }

    if (element.value == "rating") {
      const ratingValue = Number(value) || 0;
      value = (
        <div className="d-flex align-items-center">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star
              key={star}
              size={14}
              fill={star <= Math.round(ratingValue) ? "#ffc107" : "none"}
              color={star <= Math.round(ratingValue) ? "#ffc107" : "#e4e5e9"}
              style={{ marginRight: "2px" }}
            />
          ))}
          {ratingValue > 0 && <span className="ms-1" style={{ fontSize: "12px" }}>({ratingValue})</span>}
        </div>
      );
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  })
  return (
    <Card className="driver-trip-details">
      <CardBody>
        <Row>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                {Table1Data}
              </tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                {Table2Data}
              </tbody>
            </table>
            
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default TripDetails;
